<template functional>
  <div class="generating-indicator">
    <div class="generating-indicator__item"></div>
    <div class="generating-indicator__item"></div>
    <div class="generating-indicator__item"></div>
  </div>
</template>

<script>
export default {
  name: "AsyncDownloadDialogLoader"
};
</script>

<style lang="scss" scoped>
.generating-indicator {
  display: flex;
  margin-left: $spacing * 0.4;
  margin-top: $spacing;
  & > &__item + &__item {
    margin-left: $spacing * 0.25;
  }

  & > &__item {
    width: 2px;
    height: 2px;
    background: rgba(0, 0, 0, 0.26);
    border-radius: 50%;
    animation: dots 1.4s linear infinite;

    &:nth-child(2) {
      animation-delay: -1.2s;
    }

    &:nth-child(3) {
      animation-delay: -1s;
    }
  }
}
@keyframes dots {
  0%,
  60%,
  100% {
    transform: initial;
  }

  30% {
    transform: scale(0.2);
  }
}
</style>
